import {IItemContent} from "@connox/typescript-library";
import React, {Suspense, useEffect, useState} from "react";
import ReactDOM from "react-dom";
import {paMainUrl, retrieveItemContent} from "./CrossSelling";
import {useCustomerSelector} from "../../../store";
import {useTranslation} from "react-i18next";
import ErrorBoundary from "../../utils/ErrorBoundary";
import SwiperConstruct from "./SwiperConstruct";

export let localCache: IItemContent[] | undefined;

const BoughtTogetherPortalComponent: React.FC<{itemId?: string}> = ({itemId}) => {
  const {t} = useTranslation();
  const {customer} = useCustomerSelector();
  const [items, setItems] = useState<IItemContent[]>([]);

  useEffect(() => {
    if (!itemId) {
      return;
    }
    const paUrl = `${paMainUrl}BoughtTogether?productRef=${itemId}&filterOutOfStock=false`;
    void retrieveItemContent(paUrl, customer).then((itemContent) => {
      localCache = itemContent;
      setItems(itemContent);
    });
  }, []);

  if (!items.length) {
    return null;
  }

  return <SwiperConstruct items={items} title={t("product.customersAlsoBought")} />;
};

const BoughtTogetherPortal: React.FC<{itemId?: string}> = ({itemId}) => {
  const parentCategoriesElement = document.getElementById("PABoughtTogether");

  if (!parentCategoriesElement) {
    return null;
  }

  return ReactDOM.createPortal(
    <Suspense fallback={null}>
      <ErrorBoundary fallback={null} occurrence="BoughtTogetherPortal">
        <BoughtTogetherPortalComponent itemId={itemId} />
      </ErrorBoundary>
    </Suspense>,
    parentCategoriesElement,
  );
};

export default BoughtTogetherPortal;
